import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from '../../../../models/base/base-component';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent extends BaseComponent implements OnChanges {
  constructor() {
    super();
  }

  @Input() dateRange = false;
  @Input() public initialSelectedDates: NgbDate[] = [];
  @Input() public startDate!: { year: number; month: number };

  //Outputs a single date unless dateRange is true
  @Output() dateSelected = new EventEmitter<NgbDate[]>();

  public clearDateSelection = new Subject<void>();

  public hoveredDate: NgbDate | null = null;
  public selectedDate: NgbDateStruct | null = null;
  public fromDate: NgbDate | null = null;
  private toDate: NgbDate | null = null;

  setupBindings(): void {
    const clearSub = this.clearDateSelection.subscribe(() => {
      this.toDate = null;
      this.selectedDate = null;
      this.fromDate = null;
      this.selectedDate = null;
    });
    this.subscriptions.push(clearSub);
  }

  setupViews(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialSelectedDates) {
      if (this.initialSelectedDates.length > 1) {
        this.fromDate = this.initialSelectedDates[0];
        this.toDate = this.initialSelectedDates[1];
      } else if (this.initialSelectedDates.length === 1) {
        this.fromDate = this.initialSelectedDates[0];
        this.selectedDate = this.initialSelectedDates[0];
      } else {
        this.fromDate = null;
        this.toDate = null;
        this.selectedDate = null;
      }
    }
    if (changes.startDate) {
      const currentDate = new Date();
      this.startDate = {
        year: currentDate.getFullYear(),
        month: currentDate.getMonth() + 1
      };
    }
  }

  public handleDateSelection(date: NgbDate) {
    if (this.dateRange) {
      this.handleDateRangeSelection(date);
    } else {
      this.selectedDate = date;
      this.fromDate = date;
      this.dateSelected.emit([date]);
    }
  }

  public handleDateRangeSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      this.dateSelected.emit([]);
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
      this.dateSelected.emit([this.fromDate, this.toDate]);
    } else {
      this.toDate = null;
      this.fromDate = date;
      this.dateSelected.emit([]);
    }
  }

  public isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  public isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  public isFocused(date: NgbDate, focused: boolean) {
    return date.equals(this.selectedDate) || focused;
  }

  public isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
}
